import React, {useContext, useEffect, useState} from "react";
import {
    faBuilding,
    faCreditCard,
    faCube, faFileInvoice,
    faFileInvoiceDollar, faFolder, faScrewdriverWrench,
    faMoneyBillTransfer,
    faUser,
    faUserGroup
} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import styles from './sidebar.module.css';
import {useNavigate} from "react-router-dom";
import MyContext from "../../../MyContext";

const defaultFadeStart = "#7376CA";
const defaultFadeEnd = "#6E70C8";

export default function SidebarProvider({isOpen, index}) {
    const rawSettings = localStorage.getItem('system_settings');
    const systemSettings = rawSettings ? JSON.parse(rawSettings) : {};
    const [userType, setUserType] = useState(null);
    const navigate = useNavigate();
    const [items, setItems] = useState([
        {
            category: "Gestión de requerimientos",
            list: []
        },
        {
            category: "Configuración",
            list: []
        }
    ]);

    const {isClient, user} = useContext(MyContext);

    const selectionVars = () => ({
        '--sb-fade-a': systemSettings.fade_start ?? defaultFadeStart,
        '--sb-fade-b': systemSettings.secondary_color ?? defaultFadeEnd,
    });

    useEffect(() => {
        if(!user.role) return;
        const itemCopy = [
            { category: "Gestión de requerimientos", list: [] },
            { category: "Configuración", list: [] },
        ];
        let toAddClient = [];
        let toAddProvider = [];

        if(user.role.buy_order) {
            toAddProvider.push({
                name: "Consulta OC",
                icon: faFolder,
                url: "/provider/buy_order",
                selected: index === 0
            });
        }

        if (user.role.invoice) {
            toAddProvider.push({
                name: "Consulta Documentos",
                icon: faFileInvoiceDollar,
                url: "/provider/invoice",
                selected: index === 1
            });
        }

        if (user.role.invoice) {
            toAddProvider.push({
                name: "Facturas huérfanas",
                icon: faFileInvoice,
                url: "/provider/orphan_invoices",
                selected: index === 2
            });
        }

        if (user.role.financing) {
            toAddProvider.push({
                name: "Factoring",
                icon: faMoneyBillTransfer,
                url: "/financing",
                selected: index === 7
            });
        }

        if (user.role.bank_accounts) {
            toAddProvider.push({
                name: "Cuentas Bancarias",
                icon: faCreditCard,
                url: "/bank_accounts",
                selected: index === 8
            });
        }

        itemCopy[0].list = toAddProvider;

        if(isClient) {
            if(user.role.profile) {
                toAddClient.push({
                    name: "Mi Perfil",
                    icon: faUser,
                    url: "/provider/profile",
                    selected: index === 3
                });
            }

            if(user.role.company) {
                toAddClient.push({
                    name: "Empresas",
                    icon: faBuilding,
                    url: "/client/companies",
                    selected: index === 4
                });
            }
            if(user.role.user_settings) {
                toAddClient.push({
                    name: "Usuarios",
                    icon: faUserGroup,
                    url: "/client/users",
                    selected: index === 5
                });
            }
            if(user.role.user_profile) {
                toAddClient.push({
                    name: "Perfil de Usuario",
                    icon: faScrewdriverWrench,
                    url: "/client/user_profile",
                    selected: index === 6
                });
            }
        } else {
            if(user.role.profile) {
                toAddClient.push({
                    name: "Mi Perfil",
                    icon: faUser,
                    url: "/provider/profile",
                    selected: index === 3
                });
            }
        }
        itemCopy[1].list = toAddClient;
        setItems(itemCopy);
        setUserType(isClient);
    }, [user, index, isClient]);

    const shellClass = [styles.sidebarShell, !isOpen ? styles.sidebarShellNarrow : null].filter(Boolean).join(' ');

    return (
        <aside className={shellClass} aria-expanded={isOpen}>
            {items?.map((item, indexCat) => (
                <div key={indexCat}>
                    <div className={`${styles.line}`}>
                        <div>{item.category}</div>
                    </div>
                    {indexCat === 0 && (
                        <div className={styles.contextHeader}>
                            <FontAwesomeIcon className={`pe-2 ${styles.navIcon}`} size={'lg'} icon={faCube}/>
                            <div className={styles.contextHeaderLabel}>
                                {userType ? "Gestión de Cliente" : "Gestión de Proveedor"}
                            </div>
                        </div>
                    )}
                    {item?.list?.map((listItem, index2) => (
                        <div
                            key={index2}
                            onClick={() => {
                                navigate(listItem.url);
                            }}
                            role={'button'}
                            tabIndex={0}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    navigate(listItem.url);
                                }
                            }}
                            className={`${styles.navItem} ${listItem.selected ? styles.navItemSelected : ''}`}
                            style={listItem.selected ? selectionVars() : undefined}
                            title={listItem.name}
                        >
                            <FontAwesomeIcon className={`${styles.navIcon} pe-2`} size={'lg'} icon={listItem.icon}/>
                            <span className={styles.navItemText}>{listItem.name}</span>
                        </div>
                    ))}
                </div>
            ))}
        </aside>
    );
}
